'use client';

import { APS_CLIENT_IFRAME_SIZE } from "../scripts/aps-constants";
import { IFrameEventData } from "../types/iframe-event-data";
import { BusinessRule } from "../types/business-rule";

export const getInitials = (fullName: string): string => {
  if (!fullName) {
    return "";
  }

  const names = fullName.split(" ").filter(name => name.length > 0); // Split and remove empty strings
  let initials = "";

  if (names.length > 0) {
    initials += names[0].charAt(0).toUpperCase(); // First initial

    if (names.length > 1) {
      initials += names[names.length - 1].charAt(0).toUpperCase(); // Last initial
    }
  }

  return initials;
};

// Rounds to the nearest cent, defeating IEEE-754 residue (e.g. 7.105427357601002e-15) from chained subtraction
export const roundCurrency = (value: number): number => Math.round(value * 100) / 100;

export function sendMessageToParent(action: string, data: object | null) {
  if (typeof window !== 'undefined' && window.parent) {
    window.parent.postMessage({ "action": action, "data": data }, "*");
    console.log("aps-ui::" + action + " sent to client", data);
  }
};

export function isGiftCardEnabled(businessRules: BusinessRule[] | undefined): boolean {
  if (!businessRules) return false;

  const giftCardRule = businessRules.filter(a => a.ruleTypeId == 2);
  if (!giftCardRule || giftCardRule.length === 0) return false;

  const rule = giftCardRule[0];
  let giftCardEnabled = rule.isActive;
  const today = new Date();
  if (rule.startDate) {
    if (new Date(rule.startDate) <= today) {
      giftCardEnabled = true;
    }
  }
  if (rule.endDate) {
    if (new Date(rule.endDate) < today) {
      giftCardEnabled = false;
    }
  }

  return giftCardEnabled;
}

export function sendIframeSize() {
  // console.log("aps-ui::sendIframeSize: size=" + size);
  const iFrameEventData: IFrameEventData = {
    Height: 400,
    Width: 400
  };

  setTimeout(() => {
    iFrameEventData.Height = document.body.offsetHeight + 30;

    sendMessageToParent(APS_CLIENT_IFRAME_SIZE, iFrameEventData);
  }, 10);
}



// Converts a string to PascalCase (e.g., "first_name" -> "FirstName")
export const toPascalCase = (str: string): string => {
  if (!str) return '';
  return str
    .replace(/[^a-zA-Z0-9]+(.)?/g, (match, chr) => (chr ? chr.toUpperCase() : ''))
    .replace(/^./, (match) => match.toUpperCase());
};

// Recursively converts all keys of an object to PascalCase
export const toPascalCaseKeys = (obj: unknown): unknown => {
  if (Array.isArray(obj)) {
    return obj.map(toPascalCaseKeys); // Recurse on array elements
  } else if (obj !== null && typeof obj === 'object' && obj.constructor === Object) {
    return Object.keys(obj).reduce((newObj: Record<string, unknown>, key: string) => {
      const newKey = toPascalCase(key);
      newObj[newKey] = toPascalCaseKeys((obj as Record<string, unknown>)[key]); // Recurse on nested objects
      return newObj;
    }, {} as Record<string, unknown>);
  }
  return obj; // Return primitive values as-is
};


// Converts a string to PascalCase (e.g., "first_name" -> "FirstName")
export const toCamelCase = (str: string): string => {
  if (!str) return '';
  if (str == "MGID") return str;
  return str
    .replace(/[^a-zA-Z0-9]+(.)?/g, (match, chr) => (chr ? chr.toLowerCase() : ''))
    .replace(/^./, (match) => match.toLowerCase());
};

export const toCamelCaseKeys = (obj: unknown): unknown => {
  if (Array.isArray(obj)) {
    return obj.map(toCamelCaseKeys); // Recurse on array elements
  } else if (obj !== null && typeof obj === 'object' && obj.constructor === Object) {
    return Object.keys(obj).reduce((newObj: Record<string, unknown>, key: string) => {
      const newKey = toCamelCase(key);
      newObj[newKey] = toCamelCaseKeys((obj as Record<string, unknown>)[key]); // Recurse on nested objects
      return newObj;
    }, {} as Record<string, unknown>);
  }
  return obj; // Return primitive values as-is
};
